import React from "react";

import Branding from "../Branding/Branding";
import FooterEnd from "../FooterEnd/FooterEnd";
import { assetUrl} from "../../config";
import "./footer.scss";
import { useMessages } from "../../context/MessagesContext";
import { sanitize } from "../../sanitize";


const Footer: React.FC = () => {
  const { footerFootnote } = useMessages();

  return (
    <div
      className="footer"
    >
      {footerFootnote && (
        <Branding
          modifier="footer"
          logoContent={
            <img
              src={assetUrl("logo.svg")}
              width="150px"
              height="60px"
              alt=""
            />
          }
        >
          <div className="footnote" dangerouslySetInnerHTML={sanitize(footerFootnote)}></div>
        </Branding>
      )}

      <FooterEnd />
    </div>
  );
};

export default Footer;
